import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0e966b86&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=0e966b86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports